const context = require.context('./', true, /\.js/i);
context.keys().forEach(context);

window.objectToFormData = require("object-to-formdata");
window.swal = require('sweetalert');
require('@fancyapps/fancybox');
require('flexslider');
require('bootstrap-select');

// TODO: Выбрать какой-то один из range-слайдеров
require('rangeslider.js');
require('ion-rangeslider');

// TODO: Вспомнить на кой хер нужна эта бобуйня
require('sticky-sidebar/dist/jquery.sticky-sidebar');